import Head from "next/head";
import {
  SEO_DESCRIPTION,
  SEO_TITLE,
  SITE_NAME,
  buildCanonicalUrl,
  buildHomeJsonLd,
  getSiteUrl,
} from "./homeSeo";
import { ROBOTS_INDEX } from "@/lib/siteSeo";

export function HomeSeoHead() {
  const siteUrl = getSiteUrl();
  const canonical = buildCanonicalUrl("/");
  const ogImage = `${siteUrl}/images/logo.png`;
  const jsonLd = buildHomeJsonLd(siteUrl);

  return (
    <>
      <Head>
        <title>{SEO_TITLE}</title>
        <meta name="description" content={SEO_DESCRIPTION} />
        <link rel="canonical" href={canonical} />
        <meta name="robots" content={ROBOTS_INDEX} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:title" content={SEO_TITLE} />
        <meta property="og:description" content={SEO_DESCRIPTION} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:locale" content="pt_BR" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={SEO_TITLE} />
        <meta name="twitter:description" content={SEO_DESCRIPTION} />
        <meta name="twitter:image" content={ogImage} />
      </Head>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}
